import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const TimesheetsPage = lazy(() => import('@/pages/timesheets'));
const TimeSheetsManagePage = lazy(() => import('@/pages/timesheets/manage'));
const TimeSheetViewPage = lazy(() => import('@/pages/timesheets/[userId]/view'));
const TimeSheetHistoryPage = lazy(() => import('@/pages/timesheets/[userId]/view/history'));

export const timesheetsRoutes: RouteConfig = {
  path: '/timesheets',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      element: TimesheetsPage,
    },
    {
      path: '/manage',
      element: TimeSheetsManagePage,
    },
    {
      path: '/:userId/view/history',
      element: TimeSheetHistoryPage,
    },
    {
      path: '/:userId/view',
      element: TimeSheetViewPage,
    },
  ],
};
